import React from "react";
import MainWrapper from "../components/MainWrapper";
import { Link } from "react-router-dom";

export default function InfoScreen() {
  return (
    <MainWrapper>
      <div
        style={{
          width: "100%",
          border: "1px outset rgb(212, 212, 212)",
          background: "rgba(145, 163, 237, 0.9)",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          overflow: "scroll",
          textAlign: "center",
          fontStyle: "italic",
          paddingInline: "100px",
        }}
      >
        <h2>WELCOME to KYEWB HOTEL</h2>
        <p>
          We've had many visitors, and most have never come back again, because
          they never left! Getting a room is easy. Getting out again isn't! Can
          you end your visit before the rooms of the KYEWB reconfigure?
        </p>
        <h3>YOU WHAT MATE?</h3>
        <p>
          Here, please test yourself with our <a href="/warning">FREE DEMO</a>{" "}
          visit before entering the <a href="/warning">MAIN GAME</a>.
        </p>
        <h3>HOW IT WORKS</h3>
        <p>
          The entrance fee is £3.33, and for that you can play as many times as
          you like.
        </p>

        <h3>CREDITS</h3>
        <p>
          Created, Written & Coded by{" "}
          <a
            href="https://bonebooks.house/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Jonathan M Chandler
          </a>
        </p>
        <p>
          Sound by{" "}
          <a
            href="https://ditchpawn.bandcamp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ditch Pawn
          </a>
        </p>
        <p>
          Cover Art by{" "}
          <a
            href="https://www.brycedavidsonart.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bryce Davidson
          </a>
        </p>
        <p>
          Web Design and Development:{" "}
          <a
            href="https://www.instagram.com/han__993/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Hannah Lacey
          </a>
        </p>
        <p>
          Server & Deployment:{" "}
          <a
            href="https://www.instagram.com/misteroldendays/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Peter Job
          </a>
        </p>
        <h2>THANK YOU VERY MUCH, The Management.</h2>
        <p>
          Please consider putting coin in the{" "}
          <a
            href="https://ko-fi.com/newmancruise"
            target="_blank"
            rel="noopener noreferrer"
          >
            TIPS JAR
          </a>
        </p>
        <p> Contact KYEWB HQ: Bilnod@yahoo.com</p>
      </div>
    </MainWrapper>
  );
}
